import { jsxs as c, jsx as i, Fragment as k } from "react/jsx-runtime";
import * as h from "react";
import B, { useState as x, useEffect as D, forwardRef as N } from "react";
import { Table as u, Heading as _, BodyShort as w, BodyLong as M, Tabs as O } from "@navikt/ds-react";
import $ from "dayjs";
let T = 0;
function C(e) {
  const [s, t] = x(e), n = e || s;
  return D(() => {
    s == null && (T += 1, t(`aksel-icon-${T}`));
  }, [s]), n;
}
const I = B.useId;
function S(e) {
  var s;
  return I !== void 0 ? I().replace(/(:)/g, "") : (s = C(e)) !== null && s !== void 0 ? s : "";
}
var R = function(e, s) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && s.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      s.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
};
const P = N((e, s) => {
  var { title: t, titleId: n } = e, a = R(e, ["title", "titleId"]);
  let o = S();
  return o = t ? n || "title-" + o : void 0, h.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: s, "aria-labelledby": o }, a),
    t ? h.createElement("title", { id: o }, t) : null,
    h.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12.75 6a.75.75 0 0 0-1.5 0v6c0 .199.079.39.22.53l2.5 2.5a.75.75 0 1 0 1.06-1.06l-2.28-2.28z", clipRule: "evenodd" })
  );
});
var F = function(e, s) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && s.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      s.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
};
const A = N((e, s) => {
  var { title: t, titleId: n } = e, a = F(e, ["title", "titleId"]);
  let o = S();
  return o = t ? n || "title-" + o : void 0, h.createElement(
    "svg",
    Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", focusable: !1, role: "img", ref: s, "aria-labelledby": o }, a),
    t ? h.createElement("title", { id: o }, t) : null,
    h.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7 7c.141.14.22.331.22.53v11a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-4.25h-2.5V21a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75V10a.75.75 0 0 1 .22-.53z", clipRule: "evenodd" })
  );
}), z = {
  office: {
    chooseBetweenOffices: "You can choose one of the following offices.",
    closed: "Closed",
    openingHoursWithoutAppointment: "Opening hours without an appointment",
    openingHours: "Opening hours",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Special opening hours",
    address: "Visiting address"
  },
  dateTime: {
    weekDayNames: {
      mon: "Monday",
      tue: "Tuesday",
      wed: "Wednesday",
      thu: "Thursday",
      fri: "Friday",
      sat: "Saturday",
      sun: "Sunday"
    },
    time: "time",
    day: "day"
  }
}, W = {
  office: {
    chooseBetweenOffices: "Du kan velje eit av disse kontora.",
    closed: "Stengt",
    openingHoursWithoutAppointment: "Opningstider når du ikkje har avtale",
    openingHours: "Opningstider",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Spesielle åpningstider",
    address: "Besøksadresse"
  },
  dateTime: {
    weekDayNames: {
      mon: "Måndag",
      tue: "Tysdag",
      wed: "Onsdag",
      thu: "Torsdag",
      fri: "Fredag",
      sat: "Laurdag",
      sun: "Søndag"
    },
    time: "tid",
    day: "dag"
  }
}, E = {
  office: {
    chooseBetweenOffices: "Du kan velge ett av de følgende kontorene.",
    closed: "Stengt",
    openingHoursWithoutAppointment: "Åpningstider når du ikke har avtale",
    openingHours: "Åpningstider",
    appointmentOnly: "Kun timeavtale",
    specialOpeningHours: "Spesielle åpningstider",
    address: "Besøksadresse"
  },
  dateTime: {
    weekDayNames: {
      mon: "Mandag",
      tue: "Tirsdag",
      wed: "Onsdag",
      thu: "Torsdag",
      fri: "Fredag",
      sat: "Lørdag",
      sun: "Søndag"
    },
    time: "tid",
    day: "dag"
  }
}, Y = {
  en: z,
  nn: W,
  no: E
}, y = (e, s) => {
  const t = Y[s], n = {
    ...E[e],
    ...t && t[e]
  };
  return (a) => n[a];
}, K = (e) => {
  if (!e)
    return "";
  let s;
  const t = e.husnummer ? ` ${e.husnummer}` : "", n = e.husbokstav ? `${e.husbokstav}` : "";
  s = `${e.gatenavn}${t}${n}`;
  let a = e && e.poststed || "";
  return a = a.toUpperCase(), s += `, ${e.postnummer} ${a}`, s;
}, U = ({ datetime: e, language: s = "nb", short: t = !1, year: n = !1 }) => {
  const a = s === "en" ? "en-gb" : "nb";
  let o;
  return t && n ? o = "D. MMMM YYYY" : t ? o = "D. MMMM" : o = "L", e && $(e).locale(a).format(o);
}, V = {
  Mandag: "mon",
  Tirsdag: "tue",
  Onsdag: "wed",
  Torsdag: "thu",
  Fredag: "fri"
}, G = (e, s) => {
  const t = y("dateTime", s)("weekDayNames"), { dato: n, dag: a } = e;
  return n ? U({
    datetime: n,
    language: s,
    short: !0,
    year: !0
  }) : a ? t[V[a]] : "";
}, q = "_srOnly_1ti4y_1", J = {
  srOnly: q
}, H = ({ openingHours: e, language: s }) => {
  const t = y("office", s), n = y("dateTime", s), a = t("closed"), o = t("appointmentOnly"), l = n("day"), m = n("time"), g = (r) => r ? r.replace(":", ".") : "", b = (r) => r.kunTimeavtale === "true" ? o : r.fra && r.til ? `${g(r.fra)}–${g(r.til)}` : a;
  return /* @__PURE__ */ c(u, { children: [
    /* @__PURE__ */ i(u.Header, { className: J.srOnly, children: /* @__PURE__ */ c(u.Row, { children: [
      /* @__PURE__ */ i(u.HeaderCell, { scope: "col", children: l }),
      /* @__PURE__ */ i(u.HeaderCell, { scope: "col", children: m })
    ] }) }),
    /* @__PURE__ */ i(u.Body, { children: e.map((r, f) => {
      const p = G(r, s);
      return /* @__PURE__ */ c(u.Row, { shadeOnHover: !1, children: [
        /* @__PURE__ */ i(u.HeaderCell, { className: "dayInformation", children: p }),
        /* @__PURE__ */ i(u.DataCell, { className: "openingInformation", children: b(r) })
      ] }, f);
    }) })
  ] });
}, L = ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag"], Q = (e) => {
  var n, a;
  const s = (n = e.aapningstider) == null ? void 0 : n.reduce(
    (o, l) => (l.dato ? o.exceptions.push(l) : o.regular.push(l), o),
    {
      regular: [],
      exceptions: []
    }
  ), t = (s == null ? void 0 : s.regular) || [];
  return t == null || t.sort((o, l) => L.indexOf(o.dag) - L.indexOf(l.dag)), {
    address: K(e.besoeksadresse),
    addressExtra: (a = e.besoeksadresse) == null ? void 0 : a.adresseTilleggsnavn,
    openingHoursExceptions: (s == null ? void 0 : s.exceptions) || [],
    openingHours: t,
    adkomstbeskrivelse: e.adkomstbeskrivelse
  };
}, X = (e) => {
  const s = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  return e.filter((t) => !!(t.dato && t.dato >= s)).sort((t, n) => {
    const a = new Date(t.dato).getTime(), o = new Date(n.dato).getTime();
    return a - o;
  });
}, Z = "_singleReception_rdj2p_1", ee = "_heading_rdj2p_48", ne = "_headingIcon_rdj2p_53", te = "_iconPlace_rdj2p_58", se = "_iconClock_rdj2p_63", ae = "_iconInfo_rdj2p_68", oe = "_address_rdj2p_75", re = "_addressLine_rdj2p_82", ie = "_addressExtra_rdj2p_82", d = {
  singleReception: Z,
  heading: ee,
  headingIcon: ne,
  iconPlace: te,
  iconClock: se,
  iconInfo: ae,
  address: oe,
  addressLine: re,
  addressExtra: ie
}, j = (e) => {
  const { language: s } = e, t = y("office", s), { address: n, adkomstbeskrivelse: a, openingHours: o, openingHoursExceptions: l, addressExtra: m } = Q(e), g = X(l), b = e.officeType === "HMS" ? t("openingHours") : t("openingHoursWithoutAppointment");
  return /* @__PURE__ */ c("div", { className: d.singleReception, children: [
    /* @__PURE__ */ c(_, { level: "3", size: "medium", spacing: !0, className: d.heading, children: [
      /* @__PURE__ */ i(A, { "aria-hidden": "true", className: `${d.headingIcon} ${d.iconPlace}` }),
      t("address")
    ] }),
    /* @__PURE__ */ c("section", { className: d.address, children: [
      m && /* @__PURE__ */ i(w, { className: d.addressExtra, children: m }),
      /* @__PURE__ */ i(w, { className: d.addressLine, children: n }),
      a && /* @__PURE__ */ i(w, { className: d.addressLine, size: "small", children: a })
    ] }),
    o.length > 0 && /* @__PURE__ */ c(k, { children: [
      /* @__PURE__ */ c(_, { level: "3", size: "medium", spacing: !0, className: d.heading, children: [
        /* @__PURE__ */ i(P, { "aria-hidden": "true", className: `${d.headingIcon} ${d.iconClock}` }),
        b
      ] }),
      /* @__PURE__ */ i(H, { openingHours: o, language: s })
    ] }),
    g.length > 0 && /* @__PURE__ */ c(k, { children: [
      /* @__PURE__ */ i(_, { level: "3", size: "medium", spacing: !0, children: t("specialOpeningHours") }),
      /* @__PURE__ */ i(H, { openingHours: g, language: s })
    ] })
  ] });
}, le = "_officeTabs_1uiec_1", de = "_chooseBetweenOffices_1uiec_21", ce = "_singleTab_1uiec_25", v = {
  officeTabs: le,
  chooseBetweenOffices: de,
  singleTab: ce
}, ue = (e) => ["no", "nn", "en"].includes(e) ? e : "no", he = ({ receptions: e, language: s, officeType: t }) => {
  const n = ue(s), a = y("office", n), o = (r) => {
    var f;
    return r && (r.stedsbeskrivelse || ((f = r.besoeksadresse) == null ? void 0 : f.poststed)) || "(Ukjent sted)";
  }, l = (r) => r.replace(/\s/g, "-").toLowerCase(), m = o(e[0]), [g, b] = x(l(m));
  return !e || e.length === 0 ? null : e.length === 1 ? /* @__PURE__ */ i("div", { className: v.singleTab, children: /* @__PURE__ */ i(j, { ...e[0], language: n, officeType: t }) }) : /* @__PURE__ */ c(k, { children: [
    /* @__PURE__ */ i(M, { className: v.chooseBetweenOffices, children: a("chooseBetweenOffices") }),
    /* @__PURE__ */ c(O, { value: g, onChange: b, className: v.officeTabs, children: [
      /* @__PURE__ */ i(O.List, { children: e.map((r, f) => {
        const p = o(r);
        return /* @__PURE__ */ i(O.Tab, { value: l(p), label: p }, f);
      }) }),
      e.map((r, f) => {
        const p = o(r);
        return /* @__PURE__ */ i(O.Panel, { value: l(p), className: v.singleTab, children: /* @__PURE__ */ i(j, { ...r, language: n, officeType: t }) }, f);
      })
    ] })
  ] });
};
export {
  he as Reception
};
